import { RulesLink as SharedRulesLink } from "Components/Loyalty/Shared/Overview/RulesLink";
import { getApiUrl } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Valor.Overview;

export const RulesLink = () => {
  const { t } = useResource();
  const apiUrl = getApiUrl();

  const links = [
    {
      url: t(RESOURCES.Rules.Link, { apiUrl }),
      title: t(RESOURCES.Rules.Title),
    },
    {
      url: t(RESOURCES.CurrentChallenges.Link, { apiUrl }),
      title: t(RESOURCES.CurrentChallenges.Title),
    },
  ];

  return <SharedRulesLink links={links} />;
};
